export default __webpack_public_path__ + "static/media/HistoricDeadline.2bbe8621.svg";